import React, { useRef, useEffect, useState } from "react";
import Image from "next/image";

const Marquee = ({
  items = [],
  speed = 50,
  hasShadow = true,
  isImage = false,
  isMobile = false,
}: {
  items: string[];
  speed?: number;
  hasShadow?: boolean;
  isImage?: boolean;
  isMobile?: boolean;
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [contentWidth, setContentWidth] = useState(0);

  useEffect(() => {
    if (!containerRef.current) return;
    const content = containerRef.current.querySelector(".marquee-content");
    if (content) {
      setContentWidth(content.scrollWidth);
    }
  }, [items, isMobile, isImage]);

  if (items.length === 0) {
    return null;
  }

  // 外层容器高度（仅在非图片模式时设定）
  const containerHeightClass = !isImage ? (isMobile ? "h-[80px]" : "h-[120px]") : ""; // 图片时不设定高度，由内容撑开
  return (
    <div
      ref={containerRef}
      className={`relative flex w-full items-center overflow-hidden whitespace-nowrap bg-white ${containerHeightClass}`}
    >
      {/* 左侧渐变阴影 */}
      {hasShadow && (
        <div
          className={`pointer-events-none absolute left-0 top-0 z-10 h-full bg-gradient-to-r from-white from-10% via-white/40 via-50% to-transparent to-80%
            ${isMobile ? "w-[60px]" : "w-64"}`}
        />
      )}

      {/* 跑马灯内容（重复一份实现无缝） */}
      <div
        className="marquee-content inline-flex animate-marquee"
        style={{
          animationDuration: `${contentWidth / speed}s`,
        }}
      >
        {[...items, ...items].map((item, index) =>
          isImage ? (
            <div
              key={`${item}-${index}`}
              className={`flex-none rounded-2xl p-2 shadow-sm
                ${isMobile ? "h-[231px] w-[296px]" : "h-[320px] w-[416px]"}`}
            >
              <Image
                src={item}
                alt={`image-${index}`}
                width={isMobile ? 296 : 416}
                height={isMobile ? 231 : 320}
                className="h-full w-full rounded-xl object-cover"
              />
            </div>
          ) : (
            <span key={`${item}-${index}`} className="mx-5 inline-block text-nowrap text-base text-[#4b5563]">
              {item}
            </span>
          )
        )}
      </div>

      {/* 右侧渐变阴影 */}
      {hasShadow && (
        <div
          className={`pointer-events-none absolute right-0 top-0 z-10 h-full w-64 bg-gradient-to-l from-white from-20% via-white/40 via-50% to-transparent to-80%
            ${isMobile ? "w-[60px]" : "w-64"}
          `}
        />
      )}
    </div>
  );
};

export default Marquee;
